<template>
<div class="animated fadeIn">
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col lg="12">
          <!--<h6>Simple Form</h6>-->
          <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>

            <b-form-group label="Floor Number" label-for="floorNumber">
              <b-form-input id="floorNumber" type="number" aria-describedby="liveFeedbackFloorNumber" v-model.lazy.trim="$v.form.floor_number.$model" placeholder="Floor Number" autofocus />
              <b-form-invalid-feedback id="liveFeedbackFloorNumber">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Stair Position" label-for="position">
              <v-select :options="['LEFT', 'CENTER', 'RIGHT']" v-model="$v.form.position.$model" placeholder="Select Stair Position"></v-select>
            </b-form-group>

            <b-button type="submit" variant="primary" :disabled="$v.form.$invalid">
              Submit
            </b-button>
            <b-button class="ml-1" type="reset" @click="onCancel">Cancel</b-button>
          </b-form>
          <br />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</div>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
  mapActions
} from 'vuex'
import {
  required
} from "vuelidate/lib/validators"

const formShape = {
  floor_number: "",
  position: "",
}

export default {
  name: "FloorFormEdit",
  props: {
    floor: Object
  },
  data() {
    return {
      form: Object.assign({}, formShape),
      submitted: false
    }
  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError
    },
    isDirty() {
      return this.$v.form.$anyDirty
    },
    BuildingTypeList() {
      let list = []
      Vue._.forEach(this.$store.state.BuildingTypes.all, (BuildingType) => {
        list.push({
          label: BuildingType.Buildingtypename,
          value: BuildingType.Buildingtypeid
        })
      })
      return list
    },
  },
  validations: {
    form: {
      floor_number: {
        required
      },
      position: {
        required
      },
    }
  },
  methods: {
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          this.submitted = true
          let params = {
            id: this.floor.id,
            building_id: this.$route.params.id,
            floor_number: this.$v.form.floor_number.$model,
            position: this.$v.form.position.$model,
          }
          this.$store.dispatch('floors/editFloor', params)
            .then(() => {
              this.$emit('success')
              this.showSuccessMsg()
            })
            .catch((error) => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else {
                this.showErrorMsg()
              }
            })
        })
      }
    },
    onCancel() {
      this.$emit('cancel')
    },
    onReset() {
      // Reset validation
      this.form = formShape
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    chkState(val) {
      const field = this.$v.form[val]
      return field.$dirty ? !field.$invalid : null
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    }
  },
  beforeMount() {
    this.form.floor_number = this.floor.floor_number
    this.form.position = this.floor.position
  }
}
</script>
